import { useMemo } from 'react';

export default function useUserRole(userDetails) {
  return useMemo(() => {
    const role = (userDetails?.role || userDetails?.user_role || localStorage.getItem('neuro_user_role') || '').toLowerCase();
    const isSchoolAdmin = role.includes('school') || role.includes('university');
    const isHospitalAdmin = role.includes('hospital');
    const isCorporateAdmin = role.includes('corporate');
    const isDoctor = role.includes('doctor') || role === 'doctor' || (userDetails?.role && userDetails.role.toLowerCase().includes('doctor')) || (userDetails?.user_role && userDetails.user_role.toLowerCase().includes('doctor'));
    const isTakeCareAgency = /take\s*care\s*agency/i.test(role) || /takecareagency/i.test(role) || /agency/i.test(role);

    const isHospitalDoctor = isDoctor && (() => {
      const storedFlag = localStorage.getItem("neuro_is_hospital_doctor");
      if (storedFlag === "true") return true;
      if (storedFlag === "false") return false;
      if (userDetails?.info) {
        try {
          const info = typeof userDetails.info === 'string' ? JSON.parse(userDetails.info) : userDetails.info;
          return info && info.hospital_id;
        } catch {
          return false;
        }
      }
      try {
        const storedInfo = localStorage.getItem("neuro_user_info");
        if (storedInfo) {
          const info = JSON.parse(storedInfo);
          if (info && info.hospital_id) return true;
        }
      } catch {
        // Ignore parse errors
      }
      return false;
    })();

    return {
      isSchoolAdmin,
      isHospitalAdmin,
      isCorporateAdmin,
      isDoctor,
      isHospitalDoctor,
      isTakeCareAgency,
      role,
    };
  }, [userDetails]);
}
